<div class="padded-side-nav">
  <tools-multi-nav-category-select [navItems]="list"></tools-multi-nav-category-select>
</div>